import {useState, useEffect} from 'react'
import {v1} from 'uuid'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
/**
 * Custom React hook for managing Riskified beacon and domain values based on the provided site ID.
 *
 * Initializes and returns a unique Riskified beacon identifier and sets the appropriate Riskified domain
 * depending on whether the site is US or EU. The beacon is generated only if not already set, and the domain
 * is determined from the application configuration.
 *
 * @param {string} siteId - The identifier of the current site, used to determine the Riskified domain.
 * @returns {{riskifiedBeacon: string, riskifiedDomain: string}} An object containing the unique Riskified beacon and the selected domain.
 */
const useRiskified = (siteId) => {
    const [riskifiedBeacon, setRiskifiedBeacon] = useState('')
    const [riskifiedDomain, setRiskifiedDomain] = useState('')
    const {app: appConfig} = getConfig()

    useEffect(() => {
        // Set the riskifiedBeacon if not already set
        if (!riskifiedBeacon) {
            const newBeacon = v1()
            setRiskifiedBeacon(newBeacon)
        }

        // Determine the domain based on the siteId
        if (siteId.includes('US')) {
            setRiskifiedDomain(appConfig.RISKIFIED_US_DOMAIN)
        } else if (siteId.includes('EU')) {
            setRiskifiedDomain(appConfig.RISKIFIED_EU_DOMAIN)
        }
    }, [riskifiedBeacon, siteId])

    return {riskifiedBeacon, riskifiedDomain}
}

export default useRiskified
